// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2xgkb","clinicsSelect":"TableHeading_clinicsSelect__5nwzY"};